/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { get, noop } from 'lodash';
 
/**
  * Internal dependencies
  */
import Money from 'components/money';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import FormTextInput from 'components/forms/form-text-input';
 
/**
  * Style dependencies
  */
import './styles.scss';
import { Stack, Box, Text, Heading } from '@towersystems/towersystems-design-system';
import DateTime from 'components/date-time';
 
const NewPlanEstimate = ({ onChange = noop, subscriptionId, newPlanId, plan, addon }) => {
    const [submitting, setSubmitting] = useState(false);
    const [requesting, setRequesting] = useState(true);
    const [estimate, setEstimate] = useState(null);
    const [values, setValues] = useState({});
 
    useEffect(() => {
        setRequesting(true);

        cscom
            .estimate()
            .updateSubscription(subscriptionId, newPlanId)
            //.updateSubscription("16CRozUChvUOlKgY", "rental#retailer-rental-advanced#1year")
            .then((estimate) => setEstimate(estimate))
            .catch((a) => console.log(a))
            .finally(() => setRequesting(false));
    }, []);
 
    const getEstimate = (estimate) => {
        if (!estimate) {
            return '-';
        }
 
        if (estimate.next_invoice_estimate) {
            return get(estimate, 'next_invoice_estimate.total', 0) / 100;
        }
 
        if (estimate.invoice_estimate) {
            return get(estimate, 'invoice_estimate.total', 0) / 100;
        }
 
        return '-';
    };
 
    const getDiscounts = (estimate) => {
        if (!estimate) {
            return [];
        }
        
        if (estimate.next_invoice_estimate) {
            return get(estimate, ['next_invoice_estimate', 'discounts'], []);
        }
         
        if (estimate.invoice_estimate) {
            return get(estimate, ['invoice_estimate', 'discounts'], []);
        }
         
        return [];
    };

    const handleOnChange = (e) => {
        let a = {
            ...values
        };

        a[e.target.name] = e.target.value;
        setValues(a);
        onChange({...a});
    }

 
    return (
        <Box className='new-plan-estimate' display='flex' flexDirection='column' justifyContent='center'>
            {submitting || (requesting && <Preloader />)}
            <Stack space='medium'>
                <div style={{ fontSize: 22, textAlign: 'center', fontWeight: 'bold' }}>{plan.name}</div>
                <Text align='center' size='xsmall'>
                    {plan.description}
                </Text>
                <Box padding='large'>
                    <div style={{ fontSize: 18, textAlign: 'left', paddingBottom: 26 }}>
                        Plan Price: AUD <Money value={plan.price / 100} /> /{' '} {plan.period} {plan.period_unit}
                    </div>
                    {(plan.setup_cost) && (plan.setup_cost>0) && (
                    <div style={{ fontSize: 18, textAlign: 'left', paddingBottom: 26 }}>
                        Setup Cost: AUD <Money value={plan.setup_cost / 100} />
                    </div>)}

                    <div style={{ fontSize: 18, textAlign: 'left' }}>
                    </div>
                </Box>

            </Stack>
        </Box>
    );
};
 
export default NewPlanEstimate;
 